<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :small="!isOnMobile" style="position: absolute;left: 130px;transform: translate(-50%, -50%)">
        {{ $t('vmail.btn.bulk', { count: items.length }) }}
        <v-icon class="ml-2" color="primary">mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list :dense="!isOnMobile">
      <v-list-item link @click="$emit('bulk-favorite', items)">
        <v-icon class="mr-2" color="primary" :small="!isOnMobile">mdi-star</v-icon>
        <v-list-item-title>{{ $t('vmail.btn.favorite') }}</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="$emit('bulk-unfavorite', items)">
        <v-icon class="mr-2" color="primary" :small="!isOnMobile">mdi-star-outline</v-icon>
        <v-list-item-title>{{ $t('vmail.btn.unfavorite') }}</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="$emit('bulk-mark-read', items)">
        <v-icon class="mr-2" color="primary" :small="!isOnMobile">mdi-email-open</v-icon>
        <v-list-item-title>{{ $t('vmail.btn.markRead') }}</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="$emit('bulk-mark-unread', items)">
        <v-icon class="mr-2" color="primary" :small="!isOnMobile">mdi-email</v-icon>
        <v-list-item-title>{{ $t('vmail.btn.markUnread') }}</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="$emit('bulk-xfer-msg', items)">
        <v-icon class="mr-2" color="primary" :small="!isOnMobile">mdi-phone-forward</v-icon>
        <v-list-item-title>{{ $t('vmail.btn.xfer') }}</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="$emit('bulk-move-to-custom-folder', items)">
        <v-icon class="mr-2" color="primary" :small="!isOnMobile">mdi-folder</v-icon>
        <v-list-item-title>{{ $t('vmail.btn.moveToCustomFolder') }}</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="$emit('bulk-remove-from-custom-folder', items)">
        <v-icon class="mr-2" color="primary" :small="!isOnMobile">mdi-folder-off</v-icon>
        <v-list-item-title>{{ $t('vmail.btn.removeFromCustomFolder') }}</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="$emit('bulk-del-msg', items)">
        <v-icon class="mr-2" color="red" :small="!isOnMobile">mdi-delete</v-icon>
        <v-list-item-title>{{ $t('vmail.btn.del') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'voicemail-msgs-bulk-btn',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isOnMobile () {
      return this.$vuetify.breakpoint.mobile
    }
  }
}
</script>

<style scoped>
</style>
